// Imports
import { Clipboard } from './Modules/clipboard.js'

document.addEventListener('DOMContentLoaded', function() {
    new Clipboard().init()

    // Initialize Tom Select
    document.querySelectorAll('.tomselect').forEach(select => {
        new TomSelect(select, {
            plugins: ['remove_button', 'clear_button'],
            create: false,
            maxItems: null, // Allow multiple selections
            render: {
                item: function(data, escape) {
                    return '<div>' + escape(data.text) + '</div>';
                },
                option: function(data, escape) {
                    return '<div>' + escape(data.text) + '</div>';
                }
            }
        });
    });
})
